import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';
import { DbContextService } from 'src/app/services/db-context.service';
import { MainService } from 'src/app/services/main.service';

export interface SerialModel {
  title: string;
  item: any;
}

@Component({
  selector: 'app-serialitem-search',
  templateUrl: './serialitem-search.component.html',
  styleUrls: ['./serialitem-search.component.css']
})
export class SerialItemSearchComponent extends DialogComponent<SerialModel, boolean> implements SerialModel,OnInit {

  constructor(public dialogService: DialogService, private db: DbContextService, private ms: MainService) { 
    super(dialogService);
  }

  title: string;
  item: any;
  cols: any;
  data: any;
  selected_snrow: any;
  loading = false;
  @ViewChild('dt') dt: any;
  FilterText: string = "";
  result: any = { result: false, RtnItem: {} };

  ngOnInit() {
    this.cols = [
      { field: 'SerialNo', header: 'Serial Number', f: 'text' },
      { field: 'Barcode', header: 'Barcode', f: 'text' },
      { field: 'RefNo', header: 'Item Code', f: 'text' },
      { field: 'Name', header: 'Name', f: 'text' },
      { field: 'SellingPrice', header: 'Rate', f: 'decimal' },
      { field: 'CostPrice', header: 'Cost', f: 'decimal' }
    ];
    
  }

  loadItems() {
    var data = {
      BranchId: this.ms.getSettings().BranchId,
      LocationId: this.ms.getSettings().LocId,
      SellingPricelevel: this.ms.getSettings().SellingPriceLevelId,
      FilterText: this.FilterText
    }
    this.loading = true;
    this.db.Get_SerialItemSearch(data).subscribe(res => {
      if (res.Success) {
        this.data = res.data;
        this.loading = false;
      }
      else {
        this.loading = false;
      }
    });
  }

  FilterKeyDown(e) {
    if (e.keyCode == 13) {
      if (this.FilterText != "") {
        this.loadItems();
      }
    }
  }

  onRowSelect(e) {
    this.selected_snrow = e.data;
  }

  onRowDblClick(data) {
    this.selected_snrow = data;
    this.result.result = true;
    this.result.RtnItem = data;
    this.close();
  }


}
